/**
 * Shared hook for state and callbacks common to both sync and async Select.
 * Composed by useSyncOptions and useAsyncOptions.
 */
import { useCallback, useMemo, useState } from 'react';

import { OPEN_DROPDOWN_TRIGGER_KEYPRESS } from '../constants';

type UseSelectBaseParams = {
  disabled?: boolean;
  onBlur?: () => void;
};

export const useSelectCommonBehavior = ({
  disabled,
  onBlur,
}: UseSelectBaseParams) => {
  const [open, setOpen] = useState(false);

  const handleDismiss = useCallback(() => {
    onBlur?.();
  }, [onBlur]);

  const handleTriggerKeyDown = useMemo(() => {
    if (disabled) {
      return;
    }
    return (event: React.KeyboardEvent) => {
      if (OPEN_DROPDOWN_TRIGGER_KEYPRESS.includes(event.code)) {
        event.preventDefault();
        setOpen(true);
      }
    };
  }, [disabled]);

  return {
    open,
    setOpen,
    handleDismiss,
    handleTriggerKeyDown,
  };
};
